// extracted by mini-css-extract-plugin
export default {"host":"style_host__rjPOY","label":"style_label__ly85R","input":"style_input__7upTM"};